// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PKTHU","col":"styles_col__3KE4z"};